import auth from '../../services/auth'
import { cpfCnpj, phone } from '../../filters/string'

export default {
  props: ['user'],
  data() {
    return {
      emailConfirmed: undefined,
      cellConfirmed: undefined,
      tokenCellphone: undefined,
      tokenEmail: undefined,
      cellphoneSent: false,
      emailSent: undefined,
      errorCell: undefined,
      errorEmail: undefined,
      resentCell: undefined,
      resentEmail: undefined
    }
  },

  computed: {
    confirmCellphone() {
      return this.$store.getters.getConfirmCellphone();
    },
    confirmEmail() {
      return this.$store.getters.getConfirmEmail();
    },
    showCellphone() {
      return this.confirmCellphone && !this.isCellConfirmed;
    },
    showEmail() {
      return this.confirmEmail && !this.isEmailConfirmed && (this.isCellConfirmed || !this.confirmCellphone)
    },
    cellUser() {
      return this.user && this.user.dddCellphone + this.user.nroCellphone;
    },
    emailUser() {
      return this.user && this.user.accountAuthentication && this.user.accountAuthentication.login;
    },
    isEmailConfirmed() {
      return !!this.emailConfirmed && this.emailConfirmed == this.emailUser
    },
    isCellConfirmed() {
      return !!this.cellConfirmed && this.cellConfirmed == this.cellUser
    },
    celFormated() {
      return phone(this.user.dddCellphone + this.user.nroCellphone);
    },


  },

  watch:{
  },

  methods: {
    isOK() {
      // se for pra confirmar email e ainda nao confirmou OU se for pra confirmar cell e ainda nao confirmou
      // tem confirmacoes pendentes, portando nao esta OK
      if( (this.confirmEmail && !this.isEmailConfirmed) || (this.isCellConfirmed && !this.confirmCellphone)){
        this.tokenCellphone = undefined;
        this.tokenEmail = undefined;
        $('#modal-2fa').modal({backdrop: 'static', keyboard: false});
        if(this.confirmCellphone) {
          this.sendCellphone();
        } else if(this.confirmEmail) {
          this.sendEmail();
        }
        return false;
      }

      return true;

    },
    sendCellphone() {
      if (this.cellphoneSent == false) {
        this.errorCell = undefined;
        this.resentCell = undefined;
        this.tokenCellphone = undefined;
        auth.tokenGenerateResendNew(this.user.taxIdNumber, 'ADHESION_NEW_PHONE', this.cellUser).then(resp => {
          this.cellphoneSent = true;
          this.resentCell = true;
        }).catch(err => this.errorCell = err.data && err.data.status && err.data.status.message);
      } else
      this.sendEmail();
    },
    confirmCellphoneOTP() {
      this.errorCell = undefined;
      this.resentCell = undefined;
      auth.twoFactorAuthenticationNew(this.user.taxIdNumber, this.tokenCellphone, 'ADHESION_NEW_PHONE', this.cellUser).then(resp => {
        console.log('celular: ' + this.cellUser + ' confirmado!');
        this.cellConfirmed = this.cellUser;
        if(this.confirmEmail && !this.isEmailConfirmed) {
          this.sendEmail();
        } else {
          $('#modal-2fa').modal('hide');
          this.$emit('nextStep');
          return true;
        }
      }).catch(err => this.errorCell = err.data && err.data.status && err.data.status.message);
    },
    sendEmail() {
      this.errorEmail = undefined;
      this.resentEmail = undefined;
      this.tokenEmail = undefined;
      auth.tokenGenerateResendNew(this.user.taxIdNumber, 'ADHESION_NEW_EMAIL', this.emailUser).then(resp => {
        console.log(resp);
        this.emailphoneSent = true;
        this.resentEmail = true;
      }).catch(err => this.errorEmail = err.data && err.data.status && err.data.status.message);;
    },
    confirmEmailOTP() {
      this.errorEmail = undefined;
      this.resentEmail = undefined;
      auth.twoFactorAuthenticationNew(this.user.taxIdNumber, this.tokenEmail, 'ADHESION_NEW_EMAIL', this.emailUser).then(resp => {
        console.log(resp);
        console.log('e-mail: ' + this.emailUser + ' confirmado!');
        this.emailConfirmed = this.emailUser;
        this.$emit('nextStep');
        $('#modal-2fa').modal('hide');
        return true;
      }).catch(err => this.errorEmail = err.data && err.data.status && err.data.status.message);;;
    },
    resetSentCellPhone() {
      this.cellphoneSent = false;
      this.tokenCellphone = undefined;
    }

  },
  components: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/adhesion-confirm-2fa.js